import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Popover, Row, Skeleton,
  Pagination,
  Table, DatePicker
} from "antd";
import { useSelector } from "react-redux";
import { FaEye } from "react-icons/fa";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { BOOKING, FARE, RATES } from "../../config/constants/api";
import { Get } from "../../config/api";
import { extractTime } from "../../config/helpers";
// import moment from "moment";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

const ReservationRequests = () => {
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const token = useSelector((state) => state.user.userToken);
  const [requests, setRequests] = useState(null);
  const [latestRates, setLatestRates] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [latestFares, setLatestFares] = useState(null);
  console.log("latestFares", latestFares);
  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };
  // const data = {
  //   status: filter.status,
  //   keyword: filter.keyword,
  //   from: filter.from,
  //   to: filter.to,
  // };
  // const handleApply = () => {
  //   let from;
  //   let to;
  //   if (data.from) {
  //     from = moment(filter?.from?.$d).format("YYYY-MM-DD");
  //   }
  //   if (data.to) {
  //     to = moment(filter?.to?.$d).format("YYYY-MM-DD");
  //   }
  //   if (from || to) {
  //     getReservationRequests(
  //       paginationConfig.pageNumber,
  //       paginationConfig.limit,
  //       from,
  //       to
  //     );
  //   } else {
  //     return;
  //   }
  // };
  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
  };
  const handleClear = () => {
    resetFilter();
    getReservationRequests();
  };
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = requests
    ? `Showing records ${endIndex} of ${paginationConfig.totalDocs}`
    : "Showing records 0 of 0";

  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p
          className="mainLabel"
          style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
        >
          Filter
        </p>
      </div>
      <hr style={{ marginBottom: 10 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">From:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          style={{ width: "100%" }}
        />
        <p className="mainLabel">To:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          style={{ width: "100%" }}
        />

        <Button
          type=""
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="web-btn"
          //   onClick={() => getUsers()}
          //   onClick={handleApply}
        >
          Apply
        </Button>
        <Button
          type=""
          block
          size={"large"}
          className="web-btn"
          onClick={handleClear}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
  const getAllLatestRates = () => {
    Get(RATES.getAllLatestRates, token)
      .then((response) => {
        if (response?.status) {
          setLatestRates(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getAllLatestFares = () => {
    Get(FARE.getAllLatestFares, token)
      .then((response) => {
        if (response?.status) {
          setLatestFares(response?.data?.latestFares);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  // const getPerMileRate = (serviceType, passengerCapacity) => {
  //   if (latestFares && passengerCapacity) {
  //     let service = latestFares.find(
  //       (fare) =>
  //         fare._id.serviceType === serviceType &&
  //         fare._id.passengerCapacity === passengerCapacity
  //     );
  //     return service?.fare;
  //   }
  // };
  const getHourlyRate = (serviceType, passengerCapacity) => {
    if (latestRates) {
      let rate = latestRates.find(
        (rate) =>
          rate._id.serviceType === serviceType &&
          rate._id.passengerCapacity === passengerCapacity
      );
      return rate?.rate;
    }
  };
  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          S.NO
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Date
        </p>
      ),
      dataIndex: "date",
      key: "date",
      render: (item) => <span>{dayjs.tz(item, "UTC").format("M/D/YYYY")}</span>,
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Time
        </p>
      ),
      dataIndex: "time",
      key: "time",
      render: (item) => <span>{extractTime(item)}</span>,
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          F. Name
        </p>
      ),
      dataIndex: ["user", "firstName"],
      key: "firstName",
      render: (item) => <span>{item ? item : "-"}</span>,
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          L. Name
        </p>
      ),
      dataIndex: ["user", "lastName"],
      key: "lastName",
      render: (item) => <span>{item ? item : "-"}</span>,
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Pk-up Address
        </p>
      ),
      dataIndex: ["pickupLocation", "address"],
      key: ["pickupLocation", "address"],
      render: (item) => (
        <span>{item.length < 40 ? item : item.slice(0, 40) + "..."}</span>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Dr-off Address
        </p>
      ),
      dataIndex: ["dropoffLocation", "address"],
      key: ["dropoffLocation", "address"],
      render: (item) => (
        <span>
          {item
            ? item.length < 40
              ? item
              : item.slice(0, 40) + "..."
            : "Unknown"}
        </span>
      ),
    },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car Type
        </p>
      ),
      dataIndex: "serviceType",
      key: "serviceType",
      render: (value, item) => <span>{value + " Luxury"} </span>,
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Req Hours
        </p>
      ),
      dataIndex: "duration",
      key: "duration",
      render: (value, item) => (
        <span>{value >= 60 ? value / 60 + " hours" : value + " mins"} </span>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Discount
        </p>
      ),
      dataIndex: "duration",
      key: "duration",
      render: (value, item) => <span>{"00%"} </span>,
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Rate
        </p>
      ),
      dataIndex: "",
      key: "rate",
      render: (item) => (
        <span>
          ${getHourlyRate(item?.serviceType, item?.passengerCapacity)}Hr
        </span>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Amount
        </p>
      ),
      dataIndex: "amount",
      key: "amount",
      render: (value, item) => (
        <span>
          $
          {item?.duration < 60
            ? (
                (item?.duration *
                  getHourlyRate(item?.serviceType, item?.passengerCapacity)) /
                60
              ).toFixed(2)
            : (
                getHourlyRate(item?.serviceType, item?.passengerCapacity) *
                (item?.duration / 60)
              ).toFixed(2)}{" "}
          + per mile + overtime
        </span>
      ),
    },
    // {
    //   title: (
    //     <p className="uppercase font-euclid text-black font-bold text-xs text-center">
    //       Per mile + overtime
    //     </p>
    //   ),
    //   dataIndex: "-",
    //   key: "-",
    //   render: (value, item) => (
    //     <span>
    //     $
    //     {getPerMileRate(item?.serviceType, item?.passengerCapacity)}
    //   </span>
    //   ),
    // },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Status
        </p>
      ),
      dataIndex: "status",
      key: "status",
      render: (item) => (
        <>
          {item === "PENDING" ? (
            <span style={{ color: "#DD9F00" }}>{item}</span>
          ) : item === "PAID" ? (
            <span style={{ color: "#00D640" }}>{item}</span>
          ) : item === "UPCOMING" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ONGOING" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ARRIVED" ? (
            <span style={{ color: "#7c00ff" }}>{item}</span>
          ) : item === "COMPLETED" ? (
            <span style={{ color: "#00D640" }}>{item}</span>
          ) : (
            <span>{item}</span>
          )}
        </>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Booking No
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item) => "#" + value.slice(-4),
    },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => (
        <div className="flex justify-center">
          <div className="flex justify-center bg-[#9CFEC4] rounded-[100%] w-fit p-2">
            <FaEye
              className="text-[#089B44] cursor-pointer h-[16px] w-[16px]"
              onClick={() =>
                navigate("/reservationRequests/" + value, {
                  state: { data: item },
                })
              }
            />
            {/* <RiEdit2Fill
              className="text-[#089B44] cursor-pointer h-[16px] w-[16px]"
              onClick={() => navigate("/editUser/" + item._id)}
            /> */}
          </div>
        </div>
      ),
    },
  ];
  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
    getReservationRequests(pageNumber, paginationConfig.limit);
  };
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }

    return originalElement;
  };
  const getReservationRequests = async (pageNumber, pageSize, from, to) => {
    setLoading(true);
    Get(BOOKING.getReservationRequests, token, {
      from,
      to,
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
    })
      .then((response) => {
        if (response?.status) {
          setRequests(response.data.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error, "error");
        setLoading(false);
      });
  };
  useEffect(() => {
    getReservationRequests();
    getAllLatestRates();
    getAllLatestFares();
    // eslint-disable-next-line
  }, []);
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex justify-between items-center mt-8">
          <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black ml-8">
            Reservation Requests
          </h3>
          <div className="flex justify-center items-center">
            {/* <Input
              style={{ width: "250px" }}
              className="mainInput dashInput h-full"
              placeholder="Search"
                onChange={(e) =>
                  handleSearch(e.target.value)
                }
                onChange={(e) => handleSearch(e.target.value)}
              suffix={
                <FaSearch
                  style={{
                    color: "#818181",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                />
              }
                onPressEnter={(e) =>
                  getUsers(1, paginationConfig.limit, filter.keyword)
                }
            /> */}
            &emsp;
            <Popover
              content={filterContent}
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
              placement="bottomRight"
              arrow={false}
            >
              <Button
                style={{
                  padding: "4px 11px",
                  height: "auto",
                  borderRadius: "6px",
                  backgroundColor: "white",
                }}
              >
                <MdTune style={{ fontSize: "32px", color: "#767676" }} />
              </Button>
            </Popover>
            &emsp;
          </div>
        </div>
        <div
          className="bg-white rounded-lg  py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row style={{ overflow: "auto" }} className="px-6">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Skeleton active />
                <br />
              </div>
            ) : (
              <Table
                className="styledTable"
                dataSource={requests}
                columns={columns}
                pagination={false}
              />
            )}
          </Row>
          <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p className="font-euclid text-sm text-black">{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Pagination
                className="styledPagination"
                onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ReservationRequests;
